// extracted by mini-css-extract-plugin
module.exports = {"callout":"callout-module--callout--1CIr1","calloutExtra":"callout-module--calloutExtra--28Kok"};